import { css } from '@/styled-system/css';

export const iconStyles = css.raw({
  color: 'icon.accent.brand.hero',
  marginBottom: '100',
  minWidth: '600',
  alignSelf: 'center',
});
